<template>
    <div class="common_container">
        <el-form label-position="right" label-width="110px"  :rules="rules" :model="form" ref="form">
            <el-form-item :label="label+'中文名名称'" prop="cname" >
                <el-input v-model="form.cname" class="form-input"></el-input>
            </el-form-item>
            <el-form-item :label="label+'英文名称'" prop="ename">
                <el-input v-model="form.ename" class="form-input" ></el-input>
            </el-form-item>
            <el-row v-if="dictType == 'project_name'">
                <el-form-item label="关联二线" prop="related_user_name">
                    <el-select v-model="form.related_user_id"
                               clearable placeholder="请选择"
                               popper-class="poperWidth"
                               class="form-input"
                               @change="selectChangeEvent">
                        <el-option v-for="(item,index) in relatedList"
                                   :label="item.name" :value="item.internal_userid" :key="index">

                        </el-option>
                    </el-select>
                </el-form-item>
            </el-row>
            <el-row v-if="dictType == 'project_name'">
                <el-form-item label="关联cab组" prop="cab_group_id">
                    <el-select v-model="form.cab_group_id"
                               placeholder="请选择"
                               popper-class="poperWidth"
                               class="form-input"
                               clearable filterable>
                        <el-option v-for="(item,index) in departmentList"
                                   :label="item.name" :value="item.id" :key="index">

                        </el-option>
                    </el-select>
                </el-form-item>
            </el-row>
            <el-row v-if="dictType == 'project_name'">
                <el-form-item label="ONES项目" prop="ones_project_id">
                    <el-select v-model="form.ones_project_id"
                               placeholder="请选择"
                               :popper-append-to-body="false"
                               popper-class="poperWidth"
                               class="form-input"
                               clearable filterable
                    @change="onesSelectEvent">
                        <el-option v-for="(item,index) in onesProjectList"
                                   :label="item.name" :value="item.id" :key="index">

                        </el-option>
                    </el-select>
                </el-form-item>
            </el-row>
            <el-form-item>
                <el-button type="primary" size="small" :disabled="isEnabled" @click="submit">保存</el-button>
                <el-button type="default" size="small" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {getDictionaries} from "./system.rules";
    import services from './system.service'
    import commonServices from "@/services/common.service";
    const rules=getDictionaries()
    export default {
        name: "thirdPartyUserAdd",
        props:{
          type:{
              type:String,
              default:'add'
          },
          dictType:String,
          id:Number,
          cname:String,
          ename:String,
          label:String,
          relatedId:String,
          cabGroupID:String|Number,
          onesProjectId:String|Number,
          callback:Function,
        },
        data(){
            return{
                formName:"form",
                rules: rules,
                form:{
                    cname:'',
                    ename:'',
                    type:'',
                    related_user_id:'',
                    related_user_name:'',
                    cab_group_id:'',
                    ones_project_id:'',
                    ones_project_name:''
                },
                departmentList:[],
                relatedList:[],
                onesProjectList:[],
                isEnabled:false,
            }
        },
        created(){
            this.form.type = this.dictType
            this.getRelatedList()
            if(this.dictType == 'project_name'){
                this.getDepartmentList()
                this.getONesProjectEvent()
            }
            if (this.type=='edit'){
                this.$modal.title = "修改自定义选项"
                this.form.cname = this.cname
                this.form.ename = this.ename
                // this.selectChangeEvent(this.relatedId)
            }
        },
        methods:{
            getDepartmentList(){
                let params = {
                    departmentId:99998,
                    type:"group"
                }
                commonServices.getDepartmentList(params).then(res=>{
                    res.list.length>0 ? this.departmentList = res.list : this.departmentList = []
                    if (this.type=='edit' && this.dictType == 'project_name'){
                        this.form.cab_group_id = this.cabGroupID
                    }
                }).catch(err=>{
                    this.$message.error(err.message)
                })
            },
            getRelatedList(){
                services.getRelatedList().then(res=>{
                    this.relatedList = res
                    if (this.type=='edit' && this.dictType == 'project_name'){
                        this.form.related_user_id = this.relatedId
                        this.selectChangeEvent(this.relatedId)
                    }
                }).catch(err=>{
                    this.$message.error(err.message)
                })
            },
            getONesProjectEvent(){
                services.getOnesProject().then(res=>{
                    // console.log(res)
                    this.onesProjectList = res
                    if (this.type=='edit' && this.dictType == 'project_name'){
                        this.form.ones_project_id = this.onesProjectId
                        this.onesSelectEvent(this.onesProjectId)
                    }
                }).catch(err=>{
                    this.$message.error(err.message)
                })
            },
            onesSelectEvent(val){
                let cname = ''
                if(val){
                    cname = this.onesProjectList.filter(item=>{
                        if(item.id == val){
                            return item.name
                        }
                    })
                }
                if(cname[0]){
                    this.form.ones_project_name = cname[0].name
                }
            },
            selectChangeEvent(val){
                console.log(val)
                let cname = ''
                if(val){
                     cname = this.relatedList.filter(item=>{
                        if(item.internal_userid == val){
                            return item.name
                        }
                    })
                }
                if(cname[0]){
                    this.form.related_user_name = cname[0].name
                }
            },
            submit(){
                let formName=this.formName
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.type=='edit'){
                            this.update(this.form)
                        } else{
                            this.add(this.form)
                        }

                    }
                })
            },
            add(params){
                // console.log(params)
                services.getOptionCustomAdd(params).then(res=>{
                    this.$message.success("新增成功");
                    this.isEnabled=true
                    this.close(true);
                }).catch(err=>{
                    this.$message.error(err.message)
                })


            },
            update(params){
                let option = params
                option.id = this.id
                services.getOptionCustomEdit(option).then(res=>{
                    this.$message.success("编辑成功");
                    this.isEnabled=true
                    this.close(true);
                }).catch(err=>{
                    this.$message.error(err.message)
                })
            },

            //取消按钮
            onCancel(){
                this.close();
            },
            //取消后关闭页面
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },
        }
    }
</script>
<style scoped lang="scss">

/deep/.el-select-dropdown, .poperWidth{
     max-width:30% !important;
     -min-width: auto !important;
}

</style>
